'use memo';

import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { HeaderTabs } from '@/components/Navigation/HeaderTabs';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { Text } from '@/components/Typography/Text';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { useSuspenseQueryOperationPackageInstance } from './-queries';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_layout')({
  component: RouteComponent
});

/**
 * リリースプラン作成インスタンス詳細のレイアウト。
 *
 * 戻りリンク + パッケージ名 + タブ（詳細 / データ）を持ち、配下の
 * detail / data タブを Outlet で描画する。IT「デバイス管理ラベル発行」の
 * `_layout.tsx`（Header + Outlet）を stacktrace 用に簡略化した構成。
 */
function RouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'planningOperationsCore.releasePlanCreation.instance'
  });
  const params = Route.useParams();
  const {
    instanceId
  } = params;
  const {
    data: instance
  } = useSuspenseQueryOperationPackageInstance(instanceId);
  const tabs = [{
    to: '/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/detail',
    params,
    children: t('tabs.detail'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data',
    params,
    children: t('tabs.data'),
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <VStack className="bg-neutral-fill px-12 pt-4 gap-3">
        <Link to="/planning-operations-core">
          <Icon iconName="ChevronRight" text={t('backToCore')} variant="small" right />
        </Link>
        <Text variant="h4">{instance.name}</Text>
        <HStack>
          <HeaderTabs tabs={tabs} aria-label={t('tabs.ariaLabel')} />
        </HStack>
      </VStack>
      <Outlet />
    </div>;
}